import { Box, Button, Flex, Icon, Text } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { AiOutlineCheck, AiOutlinePlusCircle } from 'react-icons/ai'
import { BiDotsHorizontalRounded } from 'react-icons/bi'
import { useParams } from 'react-router-dom'

export function CardImpressaoPopover({
  descricao_impressao,
  codigo_produto,
  codigo_impressao,
  imagem_impressao,
  add,
  remove,
  quantityReducer,
  handleImages,
  progress,
}) {
  const [checked, setChecked] = useState(false)
  const [image, setImage] = useState(null)

  const { id } = useParams()

  function checkImpressao() {
    if (checked) {
      remove({
        codigo_impressao,
        descricao_impressao,
        codigo_produto,
        id,
      })
      setChecked(false)
    } else {
      add({
        codigo_impressao,
        descricao_impressao,
        codigo_produto,
        id,
      })
      setChecked(true)
    }
  }

  function handleImageImpression(e) {
    const file = e.target.files[0]

    //redimensionar o file para 210x200

    handleImages({
      file: file,
      codImp: codigo_impressao,
      codProd: codigo_produto,
      description: descricao_impressao,
      checkedImage: checked,
    })
    setImage(file)
  }

  useEffect(() => {
    const checkInitial = quantityReducer.find((item) => item.codigo_impressao === codigo_impressao)

    if (checkInitial) {
      setChecked(true)
    }
  }, [])

  const inputImageView = image ? URL.createObjectURL(image) : imagem_impressao

  const isInputChecked = quantityReducer.find((item) => item.codigo_impressao === codigo_impressao)

  return (
    <Button
      border={`1px solid #378BBF`}
      borderRadius={0}
      w="full"
      maxW="502px"
      bg="transparent"
      display="flex"
      alignItems="center"
      justifyContent="start"
      h="72px"
      onClick={checkImpressao}
      pr="0"
      pl="14px"
      position="relative"
      objectFit="cover"
      overflow="hidden"
    >
      {codigo_impressao === progress?.codigo_impressao && (
        <Box
          position="absolute"
          top="0"
          left="0"
          w={progress.progress + '%'}
          transition="all 0.3s ease-in-out"
          h="full"
          zIndex="2"
          bg="#1fa9ff90"
          display="flex"
          alignItems="center"
          justifyContent="center"
          opacity={progress.progress === 100 ? '0' : '1'}
        ></Box>
      )}
      <Box as="span" fontSize="14px" fontWeight="bold" display="flex" alignItems="center">
        <Box
          w="23px"
          h="23px"
          display="flex"
          alignItems="center"
          justifyContent="center"
          bg="transparent"
          border="1px solid #378BBF"
          borderRadius="50%"
          mr="5px"
          cursor="pointer"
        >
          {isInputChecked && <AiOutlineCheck color="#378BBF" fontSize="15px" ml="5px" />}
        </Box>
        <Flex flexDir="column" alignItems="start">
          <Text fontSize="14px" color="#1D1D1D" textTransform="capitalize" fontWeight="normal">
            {descricao_impressao.toLowerCase()}
          </Text>
          <Text> Cod: {codigo_impressao}</Text>
        </Flex>
      </Box>
      {inputImageView && (
        <Box ml="auto" display="flex" alignItems="center" justifyContent="center">
          <Flex
            as="label"
            htmlFor={`input-imagem-impressao-${codigo_impressao}`}
            fontSize="14px"
            color="#378BBF"
            mr="11px"
            gap="2px"
            fontWeight="normal"
            alignItems="center"
            cursor="pointer"
            zIndex={10}
            position="relative"
          >
            <input id={`input-imagem-impressao-${codigo_impressao}`} type="file" onChange={handleImageImpression} hidden />
            <Icon as={BiDotsHorizontalRounded} color="#378BBF" fontSize="30px" />
            <Text>Editar</Text>
          </Flex>
          <Box maxW="75px" w="full" borderLeft="1px solid #378BBF" h="full">
            <img src={inputImageView} alt="Imagem impressão" />
          </Box>
        </Box>
      )}

      {!inputImageView && (
        <Flex ml="auto" alignItems="center" gap="2px" pr="11px" as="label" htmlFor={`input-imagem-impressao-${codigo_impressao}`} cursor="pointer">
          <input id={`input-imagem-impressao-${codigo_impressao}`} type="file" onChange={handleImageImpression} hidden />

          <Icon as={AiOutlinePlusCircle} color="#378BBF" fontSize="25px" />
          <Text fontSize="14px" color="#378BBF" fontWeight="normal">
            Add imagem
          </Text>
        </Flex>
      )}
    </Button>
  )
}
